export default function Station({ station }: any) {
    return (
      <div className="col-span-12 sm:col-span-12 md:col-span-12 bg-white flex flex-col justify-start">
        <div className="text-3xl px-4  border-b border-r border-l w-full text-gray-900  mb-2 text-center flex justify-between items-center bg-blue-50">
          <div className="truncate uppercase font-bold">
            {station?.name}
          </div>
          <div className="border-l pl-4 text-red-600 font-bold py-3 text-3xl w-16">
            {station?.data?.length}
          </div>
        </div>
        <div className="grid grid-cols-12 gap-2  bg-white pb-2 mr-1">
          {station?.data?.map((visit: any) => (
            <div className="col-span-2 sm:col-span-2 md:col-span-2 bg-gray-100 border">
              <div className="mx-2 bg-gray-100 py-2 text-gray-800 font-bold text-3xl text-left truncate">
                {visit?.vehicle?.registration}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
}
